// import { useRef, useState } from "react";
// import Topbar from "../../../components/Topbar/Topbar";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
// import { get, post, put } from "../../../Services/ApiHandler";
// import { URLS } from "../../../Services/Constant";
// import { useEffect } from "react";
// import { delete_icon } from "../../../assets/img";
// import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
// import { toast } from "react-toastify";

// const ALL_STATES_OPTION = { value: "all", label: "All States" };
// const ALL_CITIES_OPTION = { value: "all", label: "All Cities" };

// const VideoBannersAdd = () => {
//   const location = useLocation();
//   const type = location?.state?.type;
//   const data = location?.state?.data;

//   const [selectedStates, setSelectedStates] = useState([]); // array of {value, label}
//   const [selectedCities, setSelectedCities] = useState([]); // array of {value, label}
//   const [allStatesSelected, setAllStatesSelected] = useState(false);
//   const [allCitiesSelected, setAllCitiesSelected] = useState(false);

//   const [fromDate, setFormDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [errors, setErrors] = useState({});

//   const [optionsList, setOptionsList] = useState({
//     states: [],
//     cities: [],
//   });

//   const [unavailableStateIds, setUnavailableStateIds] = useState([]);
//   const [unavailableCityIds, setUnavailableCityIds] = useState(new Set());

//   const [blocks, setBlocks] = useState([]);
//   const inputRefs = useRef([]);
//   const navigate = useNavigate();

//   const getStatesList = async () => {
//     const res = await get(`${URLS.LOCATION}?type=2`);
//     if (res?.status === "success") {
//       let filtemap = res.data.filter((state) => {
//         // if (state.value === "all") return true;
//         return !unavailableStateIds.some(
//           (unavailable) => unavailable.id === state.id,
//         );
//       });
//       const list = filtemap.map((state) => ({
//         value: state.id,
//         label: state.name,
//       }));
//       console.log(
//         "filtemap",
//         filtemap,
//         "list",
//         list,
//         "Ress",
//         res.data,
//         "unavailableStateIds",
//         unavailableStateIds,
//       );

//       setOptionsList((prev) => ({ ...prev, states: list }));
//     }
//   };

//   const getCitiesList = async (stateIds = []) => {
//     if (!stateIds.length) {
//       setOptionsList((prev) => ({ ...prev, cities: [] }));
//       return;
//     }
//     // Fetch cities for all selected states in parallel
//     const results = await Promise.all(
//       stateIds.map((id) => get(`${URLS.LOCATION}?type=3&parent_id=${id}`)),
//     );
//     const combined = results.flatMap((res) =>
//       res?.status === "success"
//         ? res.data.map((item) => ({ value: item.id, label: item.name }))
//         : [],
//     );
//     // Deduplicate
//     const unique = Array.from(
//       new Map(combined.map((c) => [c.value, c])).values(),
//     );
//     const citys = unique.filter((s) => !unavailableCityIds.has(s.value));
//     setOptionsList((prev) => ({ ...prev, cities: citys }));
//   };

//   const checkAvailableLocations = async (from, to) => {
//     if (!from || !to) return;
//     const payload = {
//       type: 3,
//       start_date: from,
//       end_date: to,
//       banner_id: data?.id,
//     };
//     const res = await post(URLS.BANNER_AVAILABILITY, payload);
//     if (res?.status === "success") {
//       if (res?.all_states_unavailable) {
//         // Everything is taken
//         setUnavailableStateIds(res.unavailable_states);
//         setUnavailableCityIds(new Set(res.unavailable_cities.map((c) => c.id)));
//       } else {
//         setUnavailableStateIds(res.unavailable_states);
//         setUnavailableCityIds(new Set(res.unavailable_cities.map((c) => c.id)));
//       }
//     }
//   };

//   const viewDetails = async (id) => {
//     const res = await get(`${URLS.BANNER_ADD}${id}/details/`);
//     if (res?.status === "success") {
//       const d = res.data;
//       setFormDate(d.start_date);
//       setToDate(d.end_date);
//       checkAvailableLocations(d.start_date, d.end_date);

//       if (d.all_states) {
//         setAllStatesSelected(true);
//         setAllCitiesSelected(true);
//         setSelectedStates([ALL_STATES_OPTION]);
//         setSelectedCities([ALL_CITIES_OPTION]);
//       } else {
//         const stateOptions = (d.states_detail || []).map((s) => ({
//           value: s.id,
//           label: s.name,
//         }));
//         const cityOptions = (d.cities_detail || []).map((c) => ({
//           value: c.id,
//           label: c.name,
//         }));
//         setSelectedStates(stateOptions);
//         setSelectedCities(cityOptions);
//         setAllStatesSelected(false);
//         setAllCitiesSelected(cityOptions.length === 0);

//         if (stateOptions.length) {
//           getCitiesList(stateOptions.map((s) => s.value));
//         }
//       }

//       setBlocks(
//         (d.images ?? []).map((item) => ({
//           ...item,
//           selectedImage: item.image,
//           fromDate: item.start_time,
//           toDate: item.end_time,
//         })),
//       );
//     }
//   };

//   useEffect(() => {
//     getStatesList();
//     if (data?.id) viewDetails(data.id);
//   }, [unavailableStateIds]);

//   const handleStateChange = (selectedOptions) => {
//     const hasAll = selectedOptions?.some((o) => o.value === "all");

//     if (hasAll) {
//       setAllStatesSelected(true);
//       setAllCitiesSelected(true);
//       setSelectedStates([ALL_STATES_OPTION]);
//       setSelectedCities([ALL_CITIES_OPTION]);
//       setOptionsList((prev) => ({ ...prev, cities: [] }));
//     } else {
//       setAllStatesSelected(false);
//       setAllCitiesSelected(false);
//       setSelectedStates(selectedOptions || []);
//       setSelectedCities([]);
//       const ids = (selectedOptions || []).map((s) => s.value);
//       if (ids.length) getCitiesList(ids);
//       else setOptionsList((prev) => ({ ...prev, cities: [] }));
//     }
//     setErrors((prev) => ({ ...prev, state: "" }));
//   };

//   const handleCityChange = (selectedOptions) => {
//     const hasAll = selectedOptions?.some((o) => o.value === "all");
//     if (hasAll) {
//       setAllCitiesSelected(true);
//       setSelectedCities([ALL_CITIES_OPTION]);
//     } else {
//       setAllCitiesSelected(false);
//       setSelectedCities(selectedOptions || []);
//     }
//     setErrors((prev) => ({ ...prev, city: "" }));
//   };

//   const handleAddBlock = () => {
//     setBlocks((prev) => [
//       ...prev,
//       { selectedImage: "", url: "", fromDate: "", toDate: "" },
//     ]);
//   };

//   const handleDeleteBlock = (indexToDelete) => {
//     setBlocks((prev) => prev.filter((_, i) => i !== indexToDelete));
//   };

//   const handleChange = (index, field, value) => {
//     const updated = [...blocks];
//     if (field === "fromDate") {
//       updated[index][field] = value;
//       if (updated[index].toDate && updated[index].toDate < value) {
//         updated[index].toDate = value;
//       }
//     } else if (field === "toDate") {
//       if (value >= updated[index].fromDate) {
//         updated[index][field] = value;
//       } else {
//         toast.error("End time cannot be before start time");
//         return;
//       }
//     } else {
//       updated[index][field] = value;
//     }
//     setBlocks(updated);
//   };

//   const handleImageChange = (index, file) => {
//     if (!file) return;
//     const updated = [...blocks];
//     updated[index].selectedImage = file;
//     updated[index].id = null;

//     const video = document.createElement("video");
//     video.preload = "metadata";
//     video.onloadedmetadata = () => {
//       window.URL.revokeObjectURL(video.src);
//       updated[index].url = Math.floor(video.duration);
//       setBlocks([...updated]);
//     };
//     video.src = URL.createObjectURL(file);
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     let hasBannerError = false;

//     if (!allStatesSelected && selectedStates.length === 0) {
//       newErrors.state = "State is required";
//     }

//     if (!fromDate) newErrors.startDate = "Start date is required";
//     if (!toDate) newErrors.endDate = "End date is required";
//     else if (fromDate && new Date(toDate) < new Date(fromDate)) {
//       newErrors.endDate = "End date cannot be before start date";
//     }

//     if (blocks.length === 0) {
//       toast.error("Please add at least one banner");
//       newErrors.blocks = "At least one banner is required";
//     }

//     blocks.forEach((block, index) => {
//       if (
//         block.selectedImage instanceof File &&
//         block.selectedImage.size > 15 * 1024 * 1024
//       ) {
//         toast.error(`Video ${index + 1} must be less than 15MB`);
//         hasBannerError = true;
//       }
//       if (!block.selectedImage || !block.fromDate || !block.toDate) {
//         hasBannerError = true;
//       }
//       if (
//         block.fromDate &&
//         block.toDate &&
//         Number(block.toDate.replace(":", "")) <=
//           Number(block.fromDate.replace(":", ""))
//       ) {
//         toast.error(`End time must be after start time (Banner ${index + 1})`);
//         hasBannerError = true;
//       }
//     });

//     if (hasBannerError) {
//       toast.error("Please fill all banner details");
//       newErrors.banner = "Invalid banner data";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     const payload = new FormData();
//     payload.append("type", 3);
//     payload.append("start_date", fromDate || "");
//     payload.append("end_date", toDate || "");

//     // ✅ Pass all_states flag + states/cities as JSON arrays
//     if (allStatesSelected) {
//       payload.append("all_states", "true");
//       payload.append("states", JSON.stringify([]));
//       payload.append("cities", JSON.stringify([]));
//     } else {
//       payload.append("all_states", "false");
//       const stateIds = selectedStates.map((s) => s.value);
//       const cityIds = allCitiesSelected
//         ? []
//         : selectedCities.map((c) => c.value);
//       payload.append("states", JSON.stringify(stateIds));
//       payload.append("cities", JSON.stringify(cityIds));
//     }

//     blocks.forEach((item) => {
//       if (type === "edit") {
//         if (item?.id) {
//           payload.append("image_ids[]", item.id);
//           payload.append("urls[]", item?.url || "");
//           payload.append("start_times[]", item?.fromDate || "");
//           payload.append("end_times[]", item?.toDate || "");
//         } else {
//           payload.append("new_images[]", item.selectedImage);
//           payload.append("new_urls[]", item?.url || "");
//           payload.append("new_start_times[]", item?.fromDate || "");
//           payload.append("new_end_times[]", item?.toDate || "");
//         }
//       } else {
//         payload.append("images[]", item.selectedImage);
//         payload.append("urls[]", item?.url || "");
//         payload.append("start_times[]", item?.fromDate || "");
//         payload.append("end_times[]", item?.toDate || "");
//       }
//     });

//     const method = type === "edit" ? put : post;
//     const res = await method(
//       `${URLS.BANNER_ADD}${type === "edit" ? `${data?.id}/edit` : "add"}/`,
//       payload,
//     );
//     if (res?.status === "success") {
//       toast.success(res?.message);
//       navigate(-1);
//     }
//   };

//   const stateOptions = [
//     ALL_STATES_OPTION,
//     ...optionsList.states,
//     //   .filter(
//     //   (s) =>
//     //     !unavailableStateIds.has(s.value) ||
//     //     selectedStates.some((sel) => sel.value === s.value),
//     // ),
//   ];

//   const cityOptions = allStatesSelected
//     ? [ALL_CITIES_OPTION]
//     : [
//         ALL_CITIES_OPTION,
//         ...optionsList.cities.filter(
//           (c) =>
//             !unavailableCityIds.has(c.value) ||
//             selectedCities.some((sel) => sel.value === c.value),
//         ),
//       ];
//   console.log(
//     "stateOptions",
//     stateOptions,
//     "citys",
//     optionsList?.states.length == 0,
//     "unavailableStateIds",
//     unavailableStateIds,
//     "optionsList?.states",
//     optionsList?.states,
//   );

//   return (
//     <div className="">
//       <Topbar header={type === "add" ? "Add Video" : "Edit Video"} />
//       <div className="d-flex gap-3 mt-4">
//         <div>
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
//             Start Date
//           </p>
//           <input
//             type="date"
//             value={fromDate}
//             max={toDate}
//             onChange={(e) => {
//               const v = e.target.value;
//               setFormDate(v);
//               setErrors((prev) => ({
//                 ...prev,
//                 startDate: v ? "" : prev.startDate,
//               }));
//             }}
//             className="input-box"
//           />
//           {errors.startDate && <p className="err">{errors.startDate}</p>}
//         </div>
//         <div>
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
//             End Date
//           </p>
//           <input
//             type="date"
//             value={toDate}
//             min={fromDate}
//             onChange={(e) => {
//               const v = e.target.value;
//               setToDate(v);
//               checkAvailableLocations(fromDate, v);
//               setErrors((prev) => ({
//                 ...prev,
//                 endDate:
//                   v && new Date(v) >= new Date(fromDate) ? "" : prev.endDate,
//               }));
//             }}
//             className="input-box"
//           />
//           {errors.endDate && <p className="err">{errors.endDate}</p>}
//         </div>
//       </div>
//       <div className="d-flex flex-wrap gap-4">
//         {/* State */}
//         <div className="col-md-5">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
//             State
//           </p>
//           <Select
//             className="select-loc"
//             options={[
//               { value: "all", label: "All States" },
//               ...optionsList?.states,
//             ]}
//             value={allStatesSelected ? [ALL_STATES_OPTION] : selectedStates}
//             onChange={handleStateChange}
//             placeholder="Select State(s)"
//             isMulti
//             closeMenuOnSelect={false}
//             isDisabled={
//               (!fromDate && !toDate) || optionsList?.states.length == 0
//             }
//           />
//           {errors.state && <p className="err">{errors.state}</p>}
//         </div>

//         {/* City — disabled if all states selected */}
//         <div className="col-md-5">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
//             City
//           </p>
//           <Select
//             className="select-loc"
//             options={[
//               { value: "all", label: "All States" },
//               ...optionsList?.cities,
//             ]}
//             value={
//               allStatesSelected || allCitiesSelected
//                 ? [ALL_CITIES_OPTION]
//                 : selectedCities
//             }
//             onChange={handleCityChange}
//             placeholder={
//               allStatesSelected
//                 ? "All Cities (auto-selected)"
//                 : "Select City(s)"
//             }
//             isMulti
//             isDisabled={allStatesSelected}
//             closeMenuOnSelect={false}
//           />
//           {errors.city && <p className="err">{errors.city}</p>}
//         </div>
//       </div>

//       {/* Dates */}

//       {/* Upload */}
//       <div className="mt-5">
//         <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
//           Upload Video Banner
//         </h2>
//         <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err">
//           Max Size: 15 mb
//         </p>
//       </div>

//       <div className="d-flex ae-jb gap-1">
//         <div className="col-md-11">
//           {blocks.map((block, index) => (
//             <div className="roles-bg" key={index}>
//               <div className="d-flex ae-jb gap-2 align-items-center">
//                 {/* Video Upload */}
//                 <div className="position-relative w-30">
//                   <div
//                     className="position-relative w-100"
//                     onClick={() => inputRefs.current[index]?.click()}
//                   >
//                     <HighlightOffRoundedIcon
//                       className="img-cancel"
//                       style={{
//                         position: "absolute",
//                         top: "5px",
//                         right: "5px",
//                         height: "20px",
//                         width: "20px",
//                         zIndex: 1,
//                         cursor: "pointer",
//                         backgroundColor: "white",
//                         borderRadius: "50%",
//                       }}
//                     />
//                     <div className="w-100 video-container">
//                       {block.selectedImage ? (
//                         typeof block.selectedImage === "string" ? (
//                           <video
//                             src={block.selectedImage}
//                             width="100%"
//                             height="120"
//                             controls
//                             autoPlay
//                             className="video-preview"
//                           />
//                         ) : (
//                           <video
//                             src={URL.createObjectURL(block.selectedImage)}
//                             width="100%"
//                             height="120"
//                             controls
//                             autoPlay
//                             muted
//                             className="video-preview"
//                           />
//                         )
//                       ) : (
//                         <div
//                           className="d-flex justify-content-center align-items-center"
//                           style={{
//                             width: "100%",
//                             height: "120px",
//                             backgroundColor: "#f5f5f5",
//                             border: "2px dashed #ddd",
//                             cursor: "pointer",
//                           }}
//                         >
//                           <span className="text-muted">
//                             Click to upload video
//                           </span>
//                         </div>
//                       )}
//                       <input
//                         ref={(el) => (inputRefs.current[index] = el)}
//                         type="file"
//                         hidden
//                         accept="video/*"
//                         onChange={(e) =>
//                           handleImageChange(index, e.target.files[0])
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Times */}
//                 <div className="d-flex gap-3 flex-grow-1 justify-content-center">
//                   <div className="time-input-container">
//                     <p className="f3 fs-xs-8 mb-1">Start Time</p>
//                     <input
//                       style={{ height: "35px", width: "140px" }}
//                       type="time"
//                       value={block.fromDate}
//                       onChange={(e) =>
//                         handleChange(index, "fromDate", e.target.value)
//                       }
//                       className="input-box time-input"
//                     />
//                   </div>
//                   <div className="time-input-container">
//                     <p className="f3 fs-xs-8 mb-1">End Time</p>
//                     <input
//                       style={{ height: "35px", width: "140px" }}
//                       type="time"
//                       value={block.toDate}
//                       min={block.fromDate}
//                       onChange={(e) =>
//                         handleChange(index, "toDate", e.target.value)
//                       }
//                       className="input-box time-input"
//                     />
//                   </div>
//                 </div>

//                 {type === "edit" && (
//                   <input
//                     type="text"
//                     value={block?.status}
//                     style={{ height: "30px", width: "100px" }}
//                     className={`${block?.status === "ongoing" ? "bg-green white" : ""} input-box text-center`}
//                     disabled
//                   />
//                 )}

//                 <button
//                   className="cust-btn"
//                   onClick={() => handleDeleteBlock(index)}
//                   type="button"
//                 >
//                   <img src={delete_icon} alt="" className="mx-2 edit-btn" />
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={handleAddBlock}
//           className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
//         >
//           Add
//         </button>
//       </div>

//       {errors.blocks && <p className="err">{errors.blocks}</p>}

//       <div className="d-flex ac-js gap-3 mt-5">
//         <button
//           onClick={() => navigate(-1)}
//           className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
//           style={{ minWidth: "20%" }}
//         >
//           Cancel
//         </button>
//         {type !== "view" && (
//           <button
//             onClick={handleSubmit}
//             className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
//             style={{ minWidth: "20%" }}
//           >
//             {type === "edit" ? "Submit" : "Add"}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VideoBannersAdd;

import { useRef, useState, useEffect, useCallback } from "react";
import Topbar from "../../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { get, post, put } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { delete_icon } from "../../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { toast } from "react-toastify";

const ALL_STATES_OPTION = { value: "all", label: "All States" };
const ALL_CITIES_OPTION = { value: "all", label: "All Cities" };

const VideoBannersAdd = () => {
  const location = useLocation();
  const type = location?.state?.type || "add";
  const data = location?.state?.data;

  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [allStatesSelected, setAllStatesSelected] = useState(false);
  const [allCitiesSelected, setAllCitiesSelected] = useState(false);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errors, setErrors] = useState({});

  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });

  const [unavailableStateIds, setUnavailableStateIds] = useState([]);
  const [unavailableCityIds, setUnavailableCityIds] = useState([]);

  const [blocks, setBlocks] = useState([]);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const hasInitialized = useRef(false);

  // ✅ FIX 1: Memoize getStatesList to prevent infinite loops
  const getStatesList = useCallback(async () => {
    try {
      const res = await get(`${URLS.LOCATION}?type=2`);
      if (res?.status === "success") {
        const list = res.data.map((state) => ({
          value: state.id,
          label: state.name,
        }));
        setOptionsList((prev) => ({ ...prev, states: list }));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to load states");
    }
  }, []);

  const getCitiesList = useCallback(async (stateIds = []) => {
    if (!stateIds.length) {
      setOptionsList((prev) => ({ ...prev, cities: [] }));
      return;
    }
    try {
      const results = await Promise.all(
        stateIds.map((id) => get(`${URLS.LOCATION}?type=3&parent_id=${id}`)),
      );
      const combined = results.flatMap((res) =>
        res?.status === "success"
          ? res.data.map((item) => ({ value: item.id, label: item.name }))
          : [],
      );
      // Deduplicate
      const unique = Array.from(
        new Map(combined.map((c) => [c.value, c])).values(),
      );
      setOptionsList((prev) => ({ ...prev, cities: unique }));
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities");
    }
  }, []);

  // ✅ FIX 3: Wrap checkAvailableLocations with useCallback
  const checkAvailableLocations = useCallback(
    async (from, to) => {
      if (!from || !to) return;
      try {
        const payload = {
          type: 3,
          start_date: from,
          end_date: to,
          banner_id: data?.id,
        };
        const res = await post(URLS.BANNER_AVAILABILITY, payload);
        if (res?.status === "success") {
          setUnavailableStateIds(res.unavailable_states || []);
          setUnavailableCityIds(res.unavailable_cities || []);
        }
      } catch (error) {
        console.error("Error checking availability:", error);
        toast.error("Failed to check availability");
      }
    },
    [data?.id],
  );

  // ✅ FIX 4: Wrap viewDetails with useCallback
  const viewDetails = useCallback(
    async (id) => {
      try {
        const res = await get(`${URLS.BANNER_ADD}${id}/details/`);
        if (res?.status === "success") {
          const d = res.data;
          setFromDate(d.start_date || "");
          setToDate(d.end_date || "");
          await checkAvailableLocations(d.start_date, d.end_date);

          if (d.all_states) {
            setAllStatesSelected(true);
            setAllCitiesSelected(true);
            setSelectedStates([ALL_STATES_OPTION]);
            setSelectedCities([ALL_CITIES_OPTION]);
          } else {
            const stateOptions = (d.states_detail || []).map((s) => ({
              value: s.id,
              label: s.name,
            }));
            const cityOptions = (d.cities_detail || []).map((c) => ({
              value: c.id,
              label: c.name,
            }));
            setSelectedStates(stateOptions);
            setSelectedCities(cityOptions);
            setAllStatesSelected(false);
            setAllCitiesSelected(cityOptions.length === 0);

            if (stateOptions.length) {
              getCitiesList(stateOptions.map((s) => s.value));
            }
          }

          setBlocks(
            (d.images ?? []).map((item) => ({
              ...item,
              selectedImage: item.image,
              fromDate: item.start_time,
              toDate: item.end_time,
            })),
          );
        }
      } catch (error) {
        console.error("Error loading details:", error);
        toast.error("Failed to load banner details");
      }
    },
    [checkAvailableLocations, getCitiesList],
  );

  // ✅ FIX 5: Separate useEffect dependencies - load states on mount
  useEffect(() => {
    getStatesList();
  }, []);

  // ✅ FIX 6: Load banner details when in edit mode
  useEffect(() => {
    if (type === "edit" && data?.id && !hasInitialized.current) {
      hasInitialized.current = true;
      viewDetails(data.id);
    }
  }, [type, data?.id, viewDetails]);

  const handleStateChange = (selectedOptions) => {
    const hasAll = selectedOptions?.some((o) => o.value === "all");

    if (hasAll) {
      setAllStatesSelected(true);
      setAllCitiesSelected(true);
      setSelectedStates([ALL_STATES_OPTION]);
      setSelectedCities([ALL_CITIES_OPTION]);
      setOptionsList((prev) => ({ ...prev, cities: [] }));
    } else {
      setAllStatesSelected(false);
      setAllCitiesSelected(false);
      setSelectedStates(selectedOptions || []);
      setSelectedCities([]);
      const ids = (selectedOptions || []).map((s) => s.value);
      if (ids.length) {
        getCitiesList(ids);
      } else {
        setOptionsList((prev) => ({ ...prev, cities: [] }));
      }
    }
    setErrors((prev) => ({ ...prev, state: "" }));
  };

  const handleCityChange = (selectedOptions) => {
    const hasAll = selectedOptions?.some((o) => o.value === "all");
    if (hasAll) {
      setAllCitiesSelected(true);
      setSelectedCities([ALL_CITIES_OPTION]);
    } else {
      setAllCitiesSelected(false);
      setSelectedCities(selectedOptions || []);
    }
    setErrors((prev) => ({ ...prev, city: "" }));
  };

  const handleAddBlock = () => {
    setBlocks((prev) => [
      ...prev,
      { selectedImage: "", url: "", fromDate: "", toDate: "" },
    ]);
  };

  const handleDeleteBlock = (indexToDelete) => {
    setBlocks((prev) => prev.filter((_, i) => i !== indexToDelete));
  };

  const handleChange = (index, field, value) => {
    const updated = [...blocks];
    if (field === "fromDate") {
      updated[index][field] = value;
      // ✅ FIX 7: Fixed time comparison (convert to comparable format)
      if (updated[index].toDate && updated[index].toDate < value) {
        updated[index].toDate = value;
      }
    } else if (field === "toDate") {
      if (value >= updated[index].fromDate) {
        updated[index][field] = value;
      } else {
        toast.error("End time cannot be before start time");
        return;
      }
    } else {
      updated[index][field] = value;
    }
    setBlocks(updated);
  };

  const handleImageChange = (index, file) => {
    if (!file) return;

    // ✅ FIX 8: Improved error handling for video loading
    const updated = [...blocks];
    updated[index].selectedImage = file;
    updated[index].id = null;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      const duration = Math.floor(video.duration);
      window.URL.revokeObjectURL(video.src);
      updated[index].url = duration;
      setBlocks([...updated]);
    };

    video.onerror = () => {
      toast.error("Invalid video file");
      window.URL.revokeObjectURL(video.src);
    };

    video.src = URL.createObjectURL(file);
  };

  const validateForm = () => {
    const newErrors = {};
    let hasBannerError = false;

    if (!allStatesSelected && selectedStates.length === 0) {
      newErrors.state = "State is required";
    }

    if (!fromDate) {
      newErrors.startDate = "Start date is required";
    }
    if (!toDate) {
      newErrors.endDate = "End date is required";
    } else if (fromDate && new Date(toDate) < new Date(fromDate)) {
      newErrors.endDate = "End date cannot be before start date";
    }

    if (blocks.length === 0) {
      toast.error("Please add at least one banner");
      newErrors.blocks = "At least one banner is required";
    }

    // ✅ FIX 9: Better block validation with early error detection
    blocks.forEach((block, index) => {
      // Check file size
      if (
        block.selectedImage instanceof File &&
        block.selectedImage.size > 15 * 1024 * 1024
      ) {
        toast.error(`Video ${index + 1} must be less than 15MB`);
        hasBannerError = true;
      }

      // Check required fields
      if (!block.selectedImage || !block.fromDate || !block.toDate) {
        hasBannerError = true;
      }

      // ✅ FIX 10: Better time comparison (time format HH:mm)
      if (block.fromDate && block.toDate && block.toDate <= block.fromDate) {
        toast.error(`End time must be after start time (Banner ${index + 1})`);
        hasBannerError = true;
      }
    });

    if (hasBannerError) {
      toast.error("Please fill all banner details");
      newErrors.banner = "Invalid banner data";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      const payload = new FormData();
      payload.append("type", 3);
      payload.append("start_date", fromDate || "");
      payload.append("end_date", toDate || "");

      // ✅ FIX 11: Cleaner state/city handling
      if (allStatesSelected) {
        payload.append("all_states", "true");
        payload.append("states", JSON.stringify([]));
        payload.append("cities", JSON.stringify([]));
      } else {
        payload.append("all_states", "false");
        const stateIds = selectedStates.map((s) => s.value);
        const cityIds = allCitiesSelected
          ? []
          : selectedCities.map((c) => c.value);
        payload.append("states", JSON.stringify(stateIds));
        payload.append("cities", JSON.stringify(cityIds));
      }

      // ✅ FIX 12: Simplified block payload construction
      blocks.forEach((item, index) => {
        if (type === "edit") {
          if (item?.id) {
            // Existing image
            payload.append("image_ids[]", item.id);
            payload.append("urls[]", item?.url || "");
            payload.append("start_times[]", item?.fromDate || "");
            payload.append("end_times[]", item?.toDate || "");
          } else {
            // New image
            payload.append("new_images[]", item.selectedImage);
            payload.append("new_urls[]", item?.url || "");
            payload.append("new_start_times[]", item?.fromDate || "");
            payload.append("new_end_times[]", item?.toDate || "");
          }
        } else {
          // Add mode
          payload.append("images[]", item.selectedImage);
          payload.append("urls[]", item?.url || "");
          payload.append("start_times[]", item?.fromDate || "");
          payload.append("end_times[]", item?.toDate || "");
        }
      });

      const method = type === "edit" ? put : post;
      const endpoint =
        type === "edit"
          ? `${URLS.BANNER_ADD}${data?.id}/edit/`
          : `${URLS.BANNER_ADD}add/`;

      const res = await method(endpoint, payload);
      if (res?.status === "success") {
        toast.success(res?.message);
        navigate(-1);
      } else {
        toast.error(res?.message || "Failed to save banner");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to save banner. Please try again.");
    }
  };

  // ✅ FIX 13: Cleaner options list construction
  const stateOptions = [
    ...(unavailableStateIds.length === 0 ? [ALL_STATES_OPTION] : []),
    ...optionsList.states.filter(
      (s) =>
        !unavailableStateIds.some(
          (unavailable) => unavailable.id === s.value,
        ) || selectedStates.some((sel) => sel.value === s.value),
    ),
  ];

  const selectedStateIds = selectedStates.map((s) => s.value);
  const hasUnavailableCityInSelectedStates = unavailableCityIds.some((city) =>
    selectedStateIds.includes(city.state_id),
  );

  const cityOptions = allStatesSelected
    ? [ALL_CITIES_OPTION]
    : [
        ...(!hasUnavailableCityInSelectedStates ? [ALL_CITIES_OPTION] : []),
        ...optionsList.cities.filter(
          (c) =>
            !unavailableCityIds.some(
              (unavailable) => unavailable.id === c.value,
            ) || selectedCities.some((sel) => sel.value === c.value),
        ),
      ];

  const isStatesLoading = optionsList?.states.length === 0 && type !== "view";
  console.log(
    "unavailableStateIdsunavailableStateIds",
    unavailableCityIds,
    selectedStates,
  );

  return (
    <div className="">
      <Topbar header={type === "add" ? "Add Video" : "Edit Video"} />

      {/* Date Selection */}
      <div className="d-flex gap-3 mt-4">
        <div>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
            Start Date
          </p>
          <input
            type="date"
            value={fromDate}
            max={toDate}
            onChange={(e) => {
              const v = e.target.value;
              setFromDate(v);
              setErrors((prev) => ({
                ...prev,
                startDate: v ? "" : prev.startDate,
              }));
            }}
            className="input-box"
          />
          {errors.startDate && <p className="err">{errors.startDate}</p>}
        </div>
        <div>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
            End Date
          </p>
          <input
            type="date"
            value={toDate}
            min={fromDate}
            onChange={(e) => {
              const v = e.target.value;
              setToDate(v);
              checkAvailableLocations(fromDate, v);
              setErrors((prev) => ({
                ...prev,
                endDate:
                  v && new Date(v) >= new Date(fromDate) ? "" : prev.endDate,
              }));
            }}
            className="input-box"
          />
          {errors.endDate && <p className="err">{errors.endDate}</p>}
        </div>
      </div>

      {/* State and City Selection */}
      <div className="d-flex flex-wrap gap-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            State
          </p>
          <Select
            className="select-loc"
            options={stateOptions}
            value={allStatesSelected ? [ALL_STATES_OPTION] : selectedStates}
            onChange={handleStateChange}
            placeholder="Select State(s)"
            isMulti
            closeMenuOnSelect={false}
            isDisabled={!fromDate || !toDate || isStatesLoading}
          />
          {errors.state && <p className="err">{errors.state}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            City
          </p>
          <Select
            className="select-loc"
            options={cityOptions}
            value={
              allStatesSelected || allCitiesSelected
                ? [ALL_CITIES_OPTION]
                : selectedCities
            }
            onChange={handleCityChange}
            placeholder={
              allStatesSelected
                ? "All Cities (auto-selected)"
                : "Select City(s)"
            }
            isMulti
            isDisabled={
              !fromDate ||
              !toDate ||
              allStatesSelected ||
              selectedStates.length > 1
            }
            closeMenuOnSelect={false}
          />
          {errors.city && <p className="err">{errors.city}</p>}
        </div>
      </div>
      {/* State and City Selection */}

      <div className="d-flex flex-wrap gap-4 mt-5">
        {unavailableStateIds.length > 0 && (
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              UnAvalible State
            </p>
            <div
              className="select-loc"
              style={{
                background: "#f4f4f4",
                padding: "10px 20px",
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              {unavailableStateIds?.map((ele) => {
                return (
                  <p
                    style={{
                      background: "#828282",
                      borderRadius: 10,
                      color: "#fff",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    {ele?.name}
                  </p>
                );
              })}
            </div>
          </div>
        )}
        {unavailableCityIds.length > 0 && (
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              UnAvalible City
            </p>
            <div
              className="select-loc"
              style={{
                background: "#f4f4f4",
                padding: "10px 20px",
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              {unavailableCityIds.map((ele) => {
                return (
                  <p
                    style={{
                      background: "#828282",
                      borderRadius: 10,
                      color: "#fff",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    {ele?.name}
                  </p>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {/* </div> */}

      {/* Video Upload Section */}
      <div className="mt-5">
        <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
          Upload Video Banner
        </h2>
        <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err">
          Max Size: 15 mb
        </p>
      </div>

      <div className="d-flex ae-jb gap-1">
        <div className="col-md-11">
          {blocks.map((block, index) => (
            <div className="roles-bg" key={index}>
              <div className="d-flex ae-jb gap-2 align-items-center">
                {/* Video Upload */}
                <div className="position-relative w-30">
                  <div
                    className="position-relative w-100"
                    onClick={() => inputRefs.current[index]?.click()}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        inputRefs.current[index]?.click();
                      }
                    }}
                  >
                    <HighlightOffRoundedIcon
                      className="img-cancel"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        height: "20px",
                        width: "20px",
                        zIndex: 1,
                        cursor: "pointer",
                        backgroundColor: "white",
                        borderRadius: "50%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteBlock(index);
                      }}
                    />
                    <div className="w-100 video-container">
                      {block.selectedImage ? (
                        typeof block.selectedImage === "string" ? (
                          <video
                            src={block.selectedImage}
                            width="100%"
                            height="120"
                            controls
                            autoPlay
                            className="video-preview"
                          />
                        ) : (
                          <video
                            src={URL.createObjectURL(block.selectedImage)}
                            width="100%"
                            height="120"
                            controls
                            autoPlay
                            muted
                            className="video-preview"
                          />
                        )
                      ) : (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            width: "100%",
                            height: "120px",
                            backgroundColor: "#f5f5f5",
                            border: "2px dashed #ddd",
                            cursor: "pointer",
                          }}
                        >
                          <span className="text-muted">
                            Click to upload video
                          </span>
                        </div>
                      )}
                      <input
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="file"
                        hidden
                        accept="video/*"
                        onChange={(e) =>
                          handleImageChange(index, e.target.files?.[0])
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Time Inputs */}
                <div className="d-flex gap-3 flex-grow-1 justify-content-center">
                  <div className="time-input-container">
                    <p className="f3 fs-xs-8 mb-1">Start Time</p>
                    <input
                      style={{ height: "35px", width: "140px" }}
                      type="time"
                      value={block.fromDate}
                      onChange={(e) =>
                        handleChange(index, "fromDate", e.target.value)
                      }
                      className="input-box time-input"
                    />
                  </div>
                  <div className="time-input-container">
                    <p className="f3 fs-xs-8 mb-1">End Time</p>
                    <input
                      style={{ height: "35px", width: "140px" }}
                      type="time"
                      value={block.toDate}
                      min={block.fromDate}
                      onChange={(e) =>
                        handleChange(index, "toDate", e.target.value)
                      }
                      className="input-box time-input"
                    />
                  </div>
                </div>

                {type === "edit" && (
                  <input
                    type="text"
                    value={block?.status || ""}
                    style={{ height: "30px", width: "100px" }}
                    className={`${
                      block?.status === "ongoing" ? "bg-green white" : ""
                    } input-box text-center`}
                    disabled
                  />
                )}

                <button
                  className="cust-btn"
                  onClick={() => handleDeleteBlock(index)}
                  type="button"
                  aria-label={`Delete banner ${index + 1}`}
                >
                  <img src={delete_icon} alt="" className="mx-2 edit-btn" />
                </button>
              </div>
            </div>
          ))}
        </div>
        <button
          onClick={handleAddBlock}
          className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
          type="button"
        >
          Add
        </button>
      </div>

      {errors.blocks && <p className="err">{errors.blocks}</p>}

      {/* Action Buttons */}
      <div className="d-flex ac-js gap-3 mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
          style={{ minWidth: "20%" }}
          type="button"
        >
          Cancel
        </button>
        {type !== "view" && (
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
            style={{ minWidth: "20%" }}
            type="button"
          >
            {type === "edit" ? "Submit" : "Add"}
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoBannersAdd;
